<template>
  <div>
    <v-dialog v-model="importPresetModal" max-width="700">
      <v-card class="py-5 px-5">
        <v-card-title class="justify-center primary lighten-2 white--text">
          <div class="title">
            Import presets as JSON format
          </div>
          <div class="body-2">
            Your presets will be merged with your current presets.
          </div>
        </v-card-title>
        <v-card-text class="py-5">
          <div v-show="wrongImportFormatError" class="red py-2 px-2 v-card white--text mb-5">
            Error when trying to import your presets. Only Stringified JSON formats are allowed!
          </div>
          <v-textarea
            label="Paste your presets JSON code here"
            v-model="presetCode"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!importFileBtn" @click="importFile" class="success">
            Import presets
          </v-btn>
          <v-btn @click="importPresetModal = false" class="secondary">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-title class="headline justify-center">
          <h4>
            Save your preset locally
          </h4>
          <p class="caption">
            Save your preset as a new preset or as an existing one.
          </p>
        </v-card-title>
        <v-layout mx-5 px-5 py-5 justify-center>
          <v-row justify="center">
            <v-col cols="12">
              <v-btn @click="exportPresets" depressed class="mr-3 primary lighten-1">
                Export local presets
              </v-btn>
              <v-btn @click="importPresets" outlined class="primary--text">
                Import presets
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Preset name"
                :value="presetName"
                @input="setPresetName"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <SavedPresetsCombobox :key="dialog" />
            </v-col>
          </v-row>
        </v-layout>

        <v-card-actions>
          <v-layout>
            <v-col cols="6">
              <v-btn block color="green darken-1 white--text px-5" rounded @click="savePreset(newPresetName)">
                Save Preset
                <v-icon class="ml-3">mdi-content-save</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block color="secondary-color px-5" outlined rounded @click="closeDialog">
                Cancel
              </v-btn>
            </v-col>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import SavedPresetsCombobox from './SavedPresetsCombobox'
import { downloadFile } from '@/utils/helpers'

export default {
  name: 'Save-preset-modal',
  components: {
    SavedPresetsCombobox
  },
  data: () => ({
    presetCode: '',
    wrongImportFormatError: false,
    savedPresetFile: 'localCashierPresets.js',
    importPresetModal: false,
    newPresetName: undefined // Need to be undefined, not null for default paremeter value to work in method
  }),
  watch: {
    newPresetName (name) {
      if (name === '') {
        this.newPresetName = this.presetName
      }
    }
  },
  props: {
    dialog: { type: Boolean, required: true },
    savePreset: { type: Function, required: true },
    closeDialog: { type: Function, required: true },
    presetName: { type: String, required: true }
  },
  computed: {
    ...mapState({
      allPresets: ({ config }) => config.allPresets,
      preset: ({ config }) => config.preset
    }),
    importFileBtn () {
      let lengthAndString = this.presetCode.length > 10 && typeof this.presetCode === 'string'
      if (lengthAndString) {
        try {
          JSON.parse(this.presetCode)
        } catch {
          return false
        }
      }
      return lengthAndString
    }
  },
  methods: {
    ...mapMutations([
      'setPresets',
      'setReloadBrowserPopUp'
    ]),
    setPresetName (name) {
      this.newPresetName = name
    },
    importFile () {
      try {
        const currentPresets = localStorage.presets ? JSON.parse(localStorage.presets) : {}
        const importedPresets = typeof this.presetCode === 'string'
          ? JSON.parse(this.presetCode) : (typeof this.presetCode === 'object' ? this.presetCode : {})
        const merged = {
          ...importedPresets,
          ...currentPresets
        }
        localStorage.setItem('presets', JSON.stringify(merged))
        this.importPresetModal = false
        const newPresetsToStore = {
          ...this.allPresets,
          ...merged
        }
        this.setPresets(newPresetsToStore)
        this.setReloadBrowserPopUp()
      } catch (err) {
        this.wrongImportFormatError = true
        console.log(err)
      }
    },
    importPresets () {
      this.importPresetModal = true
    },
    exportPresets () {
      const savedPresets = localStorage.presets || JSON.stringify({})
      downloadFile(this.savedPresetFile, savedPresets)
    }
  },
  created () {
    this.setPresetName(this.preset)
  }
}
</script>

<style>

</style>
